import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ThemeIcons from '../../theme/Icons';
import ThemeContext from '../../theme/ThemeContext';

const StyledWrapper = styled.span`
  svg {
    font-size: ${(props) => (props.size ? `${props.size}px` : '14px')};
    transition: all 0.15s ease-in-out;
    :hover {
      cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};;
      color: ${(props) => (props.disabled ? props.borderColor : props.primaryColor)};
    }
  }
`;

const IconCheckbox = ({
  type,
  id,
  size,
  disabled,
  selected,
  color,
  extraProps = {},
  onChange,
}) => {

  const theme = useContext(ThemeContext);

  const selectedIcon = type === 'radio' ? ThemeIcons.misc.radioChecked : ThemeIcons.misc.checked;
  const unselectedIcon = type === 'radio' ? ThemeIcons.misc.radioUnchecked : ThemeIcons.misc.unchecked;

  return (
    <StyledWrapper {...{ size, disabled, primaryColor: color || theme.primaryColor, borderColor: theme.borderColor }}>
      <FontAwesomeIcon
        data-testid={selected ? `${id}-icon-checkbox-selected` : `${id}-icon-checkbox`}
        icon={selected ? selectedIcon : unselectedIcon}
        color={selected ? (color || theme.primaryColor) : theme.borderColor}
        size={size}
        onClick={() => { if (!disabled) onChange(!selected); }}
        {...extraProps}
      />
    </StyledWrapper>
  );
};

IconCheckbox.propTypes = {
  id: PropTypes.string,
  size: PropTypes.any,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  color: PropTypes.string,

  extraProps: PropTypes.object,
  onChange: PropTypes.func,
};

export default React.memo(IconCheckbox);
